/* Top Racing Point - caselle: foto piccola e nota sotto ogni articolo (template product.caselle).
   Lavora dopo trp-caselle.js: per ogni riga cerca la variante con lo stesso nome e, se la variante
   ha una foto o una nota (metafield variante custom.nota), le mostra nella riga. Clic sulla foto = foto grande. */
(function(){
  function ready(fn){ if(document.readyState!=='loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
  function el(tag,cls,txt){ var e=document.createElement(tag); if(cls) e.className=cls; if(txt!=null) e.textContent=txt; return e; }
  function apri(src,alt){
    var o=el('div','trp-cas-zoom'); var i=el('img'); i.src=src; i.alt=alt||'';
    var x=el('button','trp-cas-zoom__close','×'); x.type='button'; x.setAttribute('aria-label','Chiudi');
    o.appendChild(i); o.appendChild(x);
    function chiudi(){ o.remove(); document.removeEventListener('keydown',esc); }
    function esc(e){ if(e.key==='Escape') chiudi(); }
    o.addEventListener('click',chiudi); document.addEventListener('keydown',esc);
    document.body.appendChild(o);
  }
  ready(function(){
    var root=document.querySelector('[data-trp-cas]'); if(!root) return;
    var D; try{ D=JSON.parse(root.querySelector('[data-trp-cas-data]').textContent); }catch(e){ return; }
    var V=D.variants||[];
    if(!V.some(function(v){ return v.img || v.nota; })) return;
    function trova(nome){
      nome=(nome||'').trim();
      return V.filter(function(v){ return v.options.some(function(o){ return o.trim()===nome; }); })[0];
    }
    function decora(){
      root.querySelectorAll('.trp-cas__row').forEach(function(r){
        if(r.getAttribute('data-foto')) return;
        var n=r.querySelector('.trp-cas__name'); if(!n) return;
        var testo=''; n.childNodes.forEach(function(c){ if(c.nodeType===3) testo+=c.textContent; });
        var v=trova(testo); r.setAttribute('data-foto','1'); if(!v) return;
        if(v.nota){ var s=n.querySelector('.trp-cas__sku'); var p=el('span','trp-cas__nota',v.nota); if(s){ n.insertBefore(p,s); } else { n.appendChild(p); } }
        if(v.img){
          var b=el('button','trp-cas__thumb'); b.type='button'; b.setAttribute('aria-label','Vedi la foto di '+testo.trim());
          var im=el('img'); im.src=v.img; im.alt=testo.trim(); im.loading='lazy'; im.width=64; im.height=64; b.appendChild(im);
          b.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); apri(v.big||v.img,testo.trim()); });
          var c=r.querySelector('.trp-cas__check'); if(c && c.nextSibling){ r.insertBefore(b,c.nextSibling); } else { r.appendChild(b); }
        }
      });
    }
    decora();
    new MutationObserver(decora).observe(root,{childList:true,subtree:true});
  });
})();
